<template>
  <div class="container bg-light">
    <div class="row">
      <div class="col-12 col-md-4 col-lg-4 col-sm-3 bg-white pt-5 pb-5">
        <LeftSidebar />
      </div>
      <div class="col-sm-9 col-12 col-md-8 col-lg-8 bg-white pt-3 text-left">
        <HelloWorld />
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'
import LeftSidebar from '@/components/LeftSidebar.vue'
export default {
  name: 'home',
  components: {
    HelloWorld,
    LeftSidebar
  },
  
}
</script>
<style lang="scss">

</style>
